<template>
  <base-section id="financial-report" class="grey lighten-4">
    <base-section-heading color="grey lighten-2" title="Perizinan" />

    <v-container>
      <v-tabs background-color="secondary">
        <v-tab href="#tahunan">Perizinan</v-tab>

        <v-tab-item value="tahunan">
          <v-card flat>
            <v-card-text>
              <v-list-item
                v-for="card in report_ad"
                :key="card.web_report_name"
                @click="Open(card.web_report_path_url)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon>mdi-file-pdf-box</v-icon>
                    {{ card.web_report_name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Tab lainnya tetap sama -->
      </v-tabs>
    </v-container>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.dialog"
      rounded="pill"
      bottom
    >
      {{ snackbar.text }}
      <template>
        <v-btn text @click.native="snackbar.dialog = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog untuk meminta dokumen -->
    <v-dialog v-model="documentRequestDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Minta Dokumen</v-card-title>
        <v-card-text>
          <v-form ref="documentRequestForm" @submit.prevent="requestDocument">
            <v-text-field
              v-model="documentRequest.name"
              :rules="nameRules"
              label="Nama"
              required
              outlined
              class="mb-3"
            ></v-text-field>

            <v-text-field
              v-model="documentRequest.email"
              :rules="emailRules"
              label="Email"
              required
              outlined
              type="email"
              class="mb-3"
            ></v-text-field>

            <v-text-field
              v-model="documentRequest.company"
              :rules="companyRules"
              label="Perusahaan"
              required
              outlined
              class="mb-3"
            ></v-text-field>

            <v-textarea
              v-model="documentRequest.purpose"
              :rules="purposeRules"
              label="Keperluan Dokumen"
              required
              outlined
              rows="3"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="documentRequestDialog = false"
            >Batal</v-btn
          >
          <v-btn
            color="primary"
            @click="requestDocument"
            :loading="loading"
            :disabled="loading"
          >
            <template v-slot:loader>
              <span class="custom-loader">LOADING...</span>
            </template>
            Minta Dokumen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </base-section>
</template>

<script>
export default {
  name: "SectionArticlesAssociation",
  data: () => ({
    report_ad: [],
    snackbar: {
      dialog: false,
      color: "success",
      text: "",
      timeout: 3000
    },
    loading: false,
    documentRequestDialog: false,
    selectedDocumentName: "",
    documentRequest: {
      name: "",
      email: "",
      company: "",
      purpose: ""
    },
    nameRules: [
      v => !!v || "Nama harus diisi",
      v => (v && v.length >= 3) || "Nama minimal 3 karakter"
    ],
    emailRules: [
      v => !!v || "Email harus diisi",
      v => /.+@.+\..+/.test(v) || "Email harus valid"
    ],
    companyRules: [v => !!v || "Perusahaan harus diisi"],
    purposeRules: [
      v => !!v || "Keperluan dokumen harus diisi",
      v => (v && v.length >= 10) || "Keperluan minimal 10 karakter"
    ]
  }),
  created() {
    this.Report("PK");
  },
  methods: {
    Report() {
      let formdata = {
        web_report_category: "PZ",
        order_by: "web_report_year",
        order_type: "DESC"
      };
      let param = this.$functions.ParamPOST(formdata);
      this.$axios
        .post(this.$functions.UrlPOST("apiWebReportList"), param, {
          headers: {
            "Content-Type": "text/plain; charset=ISO-8859-1"
          }
        })
        .then(response => {
          let data = response.data;
          if (data.length > 0) {
            this.report_ad = data;
          } else {
            this.snackbar.value = true;
            this.snackbar.text = data[0].feedback;
          }
        })
        .catch(e => {
          this.snackbar.value = true;
          this.snackbar.text = e;
        });
    },

    showDocumentRequestDialog(url) {
      this.selectedDocumentName = url;
      this.documentRequestDialog = true;
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    requestDocument() {
      if (this.$refs.documentRequestForm.validate()) {
        this.loading = true;
        let formdata = {
          request_document_name: this.selectedDocumentName,
          request_name: this.documentRequest.name,
          request_email: this.documentRequest.email,
          request_company: this.documentRequest.company,
          request_purpose: this.documentRequest.purpose
        };

        let param = this.$functions.ParamPOST(formdata);
        this.$axios
          .post(this.$functions.UrlPOST("apiWebRequestDocument"), param, {
            headers: {
              "Content-Type": "text/plain; charset=ISO-8859-1"
            }
          })
          .then(response => {
            let feedback = response.data;
            if (feedback.length > 0) {
              if (feedback[0].feedback === "Y") {
                this.SnackBar(
                  true,
                  "success",
                  "Assalamualaikum " +
                    this.documentRequest.name +
                    ", permintaan dokumen anda telah kami terima.",
                  0
                );
                this.documentRequestDialog = false;
                this.selectedDocumentName = "";
                this.documentRequest.name = "";
                this.documentRequest.email = "";
                this.documentRequest.company = "";
                this.documentRequest.purpose = "";
              } else {
                this.SnackBar(true, "error", feedback[0].feedback, 0);
              }
              this.loading = false;
            } else {
              this.snackbar.value = true;
              this.snackbar.text = feedback[0].feedback;
            }
          })
          .catch(e => {
            this.snackbar.value = true;
            this.snackbar.text = e;
          });
      }
    },
    Open(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
::v-deep .v-list-item__icon:first-child {
  margin-right: 12px;
}
</style>